<template>
  <div class="app-content">
  <!-- :style="{
      overflow: popupIsShow ? 'hidden' : 'scroll',
    }" -->
     <div class="bg" >
      <img v-if="isSource" src="../../assets/images/headImgf.png" alt="" />
      <img v-else src="../../assets/images/headImg.png" alt="" />
    </div>
    <div class="video-container">
      <video
        :controls="controlsIsShow"
        x5-video-player-type="h5"
        :src="filterUrl(info.shareVideoUrl)"
        poster="../../assets/images/videoCover.png"
        preload="none"
        @mouseenter="controlsIsShow = true"
        @mouseleave="controlsIsShow = false"
      ></video>
    </div>
   
    <img :src="filterUrl(info.shareH5Url)" alt="" />
    <img :src="filterUrl(info.shareCodeUrl)" alt="" />
    <div v-if="isShowOpenApp" class="btn">
      <div class="openApp2Font"><span class="openIcon"></span>打开看看</div>
      <div class="openAppStyle">
          <wx-open-launch-app @click="copyLink" id="openApp2" style=" position: absolute;top: 0; left:0;width:100%;height: 100%;" appid="wx35f164d814467bdc" :extinfo="extinfoCon"  @launch="AppLaunch" @error="AppError" >
            <component is="script" type="text/wxtag-template">
              <div style=" position: absolute;top:0;left:0;width: 96%;height: 100%;border:none;background-color:transparent;"></div>
            </component>
          </wx-open-launch-app>
        </div>
    </div>
    <!-- ？？？？？？？？<div v-else class="btn" @click="download"><span class="openIcon"></span>打开看看</div> -->
    <div v-else class="btn" @click="closeWeb"><span class="openIcon"></span>打开看看</div>
    <div class="zhezhao"  v-if="dialog">
      <img src="../../assets/images/zhezhao.png" alt="" />
    </div>
    
    <transition name="el-fade-in-linear" v-if="popupIsShow" >
      <div class="popup" @click.self="closePopup">
        <div class="popup-content">
          <div class="receive-img-block" v-if="isReceive">
            <img
              src="../../assets/images/score-popup-bg.png"
              alt=""
              class="popup-bg"
            />
            <img
              src="../../assets/images/score-popup-bg-close.png"
              alt=""
              class="close-icon"
              @click="closePopup"
            />
            <div class="recBtnStyle">
              <img
                src="../../assets/images/score-popup-bg-btn.png"
                alt=""
                class="btn-bg"
                @click.stop="copyLink"
              />
            </div>
          </div>
          <div class="receive-tips-block" v-else>
            <div class="receive-tips-block-title">
              <div class="receive-tips-block-title-text">提示</div>
              <img
                class="receive-tips-block-close"
                src="../../assets/images/receive-tips-close.png"
                @click="closePopup"
              />
            </div>

            <div class="receive-tips-block-content">
              <div class="receive-tips-block-content-icon">
                <img
                  src="../../assets/images/receive-tips-content-icon.png"
                  alt=""
                />
              </div>
              <div class="receive-tips-block-content-text">
                邀请码已复制成功 请到银成圣云执业考试APP领取
              </div>
            </div>
            <div class="receive-tips-block-actions">
              <div class="cancelOpenBut">
                <img
                  src="../../assets/images/receive-tips-cancel.png"
                  alt=""
                  @click="closePopup"
                />
              </div>
              <div class="cancelOpenBut">
                <img
                  src="../../assets/images/receive-tips-confrim.png"
                  alt=""
                />
                <div class="openAppStyle" v-if="isShowOpenApp">
                  <wx-open-launch-app @click="copyLink" id="openApp" style=" position: absolute;top: 0; left:0;width:100%;height: 100%;"  appid="wx35f164d814467bdc" :extinfo="extinfoCon"  @launch="AppLaunch" @error="AppError" >
                    <component is="script" type="text/wxtag-template">
                      <div style=" position: absolute;top:0;left:0;width: 96%;height: 100%;border:none;background-color:transparent;"></div>
                    </component>
                  </wx-open-launch-app>
                </div>
                <span v-else class="openAppStyle" >

                </span>

              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import store from "@/store";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { getScoreDetail } from "@/api/score/score";
import wx from 'weixin-js-sdk'
import CryptoJS from "crypto-js";
import axios from 'axios'

export default {
  data() {
    return {
      isSource:false,
      extinfoCon:"ydddoctor://startup",
      isShowOpenApp: false,
      isReceive: true,
      controlsIsShow: false,
      popupIsShow: false,
      visitorId: "",
      info: {},
      dialog: false,
      inviteSign:null,
    };
  },
  created() {
    if(this.$route.query.source){
      this.isSource = true;
      store.dispatch("settings/setTitle", "银成圣云执业医师考试");
      this.extinfoCon = "yddsurgeon://startup"
    }else{
      
      store.dispatch("settings/setTitle", "模拟实践技能");
      this.extinfoCon = "ydddoctor://startup"
    }
    this.getDetail();
    let ua = navigator.userAgent.toLowerCase();
    if(this.isWeiXin()){
      this.popupIsShow = true;
      this.isShowOpenApp = true;
      this.getApp();
    }else{
      // this.closeWeb();
    }
    if (this.$route.query.inviteSign) {
      console.log(this.$route.query.inviteSign,"???????????",this.$route.query.inviteSign.replace(/\ /g,"+"));
      this.inviteSign =  this.$route.query.inviteSign.replace(/\ /g,"+");
      console.log(this.inviteSign);
      this.extinfoCon = this.extinfoCon + "?shareCode=" + this.inviteSign;
      // this.extinfoCon = "openapp://syyxcloud.com.doctor?shareCode=" + this.inviteSign
    } 
  },
  
  methods: {
    isWeiXin () {
      var ua = window.navigator.userAgent.toLowerCase();
      // ua.indexOf('micromessenger')为真-微信端，如果为假，就是其他浏览器
      if (ua.indexOf('micromessenger') > -1) {
        return true; // 是微信端
      } else {
        return false;
      }
    },
    closePopup() {
      this.popupIsShow = false;
      this.isReceive = true;
    },
    butLister(){
      let btn = document.getElementById("openApp");
      btn.addEventListener('ready', function (e) {
        // js中，我是在这里添加的extinfo内容，
        console.log("ready")
      })
      btn.addEventListener('launch', function (e) {
        this.copyLink();
        console.log("launch")
      })
      btn.addEventListener('error', (e)=> {
        this.copyLink();
        if(e.detail){
          this.popupIsShow = false;
          if(this.judgeClient() == "IOS"){
            window.location.href =
            "https://apps.apple.com/us/app/执业医师考试-执业医师/id6469769193";

          }else{
            this.dialog = true;
          }
        }
        console.log("error")
      })

    },
    butLister2(){
      let btn2 = document.getElementById("openApp2");
      btn2.addEventListener('ready', function (e) {
        // js中，我是在这里添加的extinfo内容，
        console.log("ready")
      })
      btn2.addEventListener('launch', function (e) {
        console.log("launch")
        this.copyLink();
      })
      btn2.addEventListener('error', (e)=> {
        this.copyLink();
        if(e.detail){
          this.popupIsShow = false;

          if(this.judgeClient() == "IOS"){
            window.location.href =
            "https://apps.apple.com/us/app/执业医师考试-执业医师/id6469769193";

          }else{
            this.dialog = true;
          }
        }
        console.log("error")
      })

    },
    getApp(){
      axios.get('https://c.medmeta.com/api/wechat/wx/jsapi/wx73d5eb8e6d65981e/getJsapiTicket').then( res => {
        if(res!=null){
          let that = this;
          let url = window.location.href;
          console.log(url)
          url = url.split('#')[0]
          
          let tick = res.data;
          let time = parseInt(new Date().getTime()/1000);
          let nums = this.suijione(true,true,false,16);
          
          let str = 'jsapi_ticket='+ tick + '&noncestr='+ nums  +'&timestamp='+ time + '&url='+ url;
          
          let signature = CryptoJS.SHA1(str).toString();
          // let appid = "wx73d5eb8e6d65981e"
          let appid = "wx73d5eb8e6d65981e"
          console.log("测试数据",tick,time,nums,str,signature,appid)
          wx.config({
            debug: false,
            appId: appid,  // 此处APPID为公众号的APPID
            timestamp: time, 
            nonceStr: nums, 
            signature: signature,
            jsApiList: ['wx-open-launch-app','onMenuShareTimeline'], //此处必须填写一个，不为null就行
            openTagList: ['wx-open-launch-app'] 
          })
          wx.ready( () => {
            console.log('ready')
            wx.checkJsApi({
              jsApiList: ['wx-open-launch-app'], // 校验跳转APP的标签是否可用
              uccess: function (res) {
                console.log('可用')
                  onsole.log('config111')
              },
              fail: (err) => {
                console.log(err, '不可用')
              }
            });
            that.butLister2();
          }) 
          wx.error(function(res){
            console.log("error：",res)
          });
            
        }
      })
    },
  AppLaunch(e){
		this.copyLink();
	},
	AppError(e){
		console.log("fail",e.detail)
	},
	// 监听error 函数
	handleErrorFn (e) {
	  // 跳转失败
	  console.log(JSON.stringify(e), '跳转失败')
	  download() // 这里跳转App下载页面
	},
    // 监听launch 函数
    handleLaunchFn (e) {
      // 跳转成功
      console.log(JSON.stringify(e), '跳转成功')
    },
    getRandom(a,b){
      var max = a;
      var min = b;
      if(a<b){
        max = b;
        min = a;
      }
      return parseInt(Math.random()*(max-min))+min;
    },
    suijione(num,maxA,minlA,fqy){
      let arr=[]
      let arr1=[]
      let arr2=[]
      if(num){
        for(let m=0;m<=9;m++){
          arr.push(m)
        }
      }
      if(maxA){
        for(let m=65;m<=90;m++){
          arr1.push(m)
        }
      }
      if(minlA){
        for(let m=97;m<=122;m++){
          arr2.push(m)
        }
      }
      if(!fqy){
        console.log('生成位数必传')
      }
      let mergeArr = arr.concat(arr1);
      let mergeArr1 = mergeArr.concat(arr2);
      let _length=mergeArr1.length
      let text=''
      for(let m=0;m<fqy;m++){
        let text1=''
        let random= this.getRandom(0,_length)
        if((mergeArr1[random])<=9){
          text1=mergeArr1[random]
        }else if((mergeArr1[random])>9){
          text1=String.fromCharCode(mergeArr1[random])
        }
        text+=text1
      }
      return text
    },
    // 复制
    copyLink() {
      let copyInput = document.createElement("input"); // 创建元素
      // 复制的字符串
      if (this.$route.query.inviteSign) {
        if(this.isSource){
          copyInput.value =
          "yddsurgeon://shareCode=" + this.inviteSign;
        }else{
          copyInput.value =
          "ydddoctor://shareCode=" + this.inviteSign;
        }
        
      } else {
        if(this.isSource){
          copyInput.value = "yddsurgeon://shareCode=''";
        }else{
          copyInput.value = "ydddoctor://shareCode=''";
        }
        
      }
      document.body.appendChild(copyInput); // 添加元素
      copyInput.select();
      document.execCommand("Copy"); // 执行浏览器复制命令
      document.body.removeChild(copyInput); // 移除刚创建的元素
      this.isReceive = false;

      this.$nextTick(()=>{
        this.butLister();
      })
    },

    download() {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.dialog = true;
      } else {
        if (this.judgeClient() == "Android") {
          //   window.location.href = 'https://file.medmeta.com/static/20231129/doctorapp.apk'
          // window.location.href = 'https://sj.qq.com/appdetail/com.yddmi.doctor'
          window.location.href = this.getPhoneType();
        } else if (this.judgeClient() == "IOS") {
          window.location.href =
            "https://apps.apple.com/us/app/执业医师考试-执业医师/id6469769193";
        } else {
        }
      }
    },

    //判断手机型号
    getPhoneType() {
      let userAgent = navigator.userAgent;
      let brand = "unknown";
      let href = "https://sj.qq.com/appdetail/com.yddmi.doctor"; //应用宝地址
      // let href = 'oppomarket://details?packagename=com.yddmi.doctor'//应用宝地址
      if (/iPhone|iPad/i.test(userAgent)) {
        brand = "Apple";
        href = "https://apps.apple.com/us/app/id6469769193";
      } else if (/HUAWEI/i.test(userAgent)) {
        brand = "HUAWEI";
        href = "appmarket://details?id=com.yddmi.doctor";
      } else if (/honor/i.test(userAgent)) {
        brand = "honor";
        href = "appmarket://details?id=com.yddmi.doctor";
      } else if (/Xiaomi/i.test(userAgent)) {
        brand = "Xiaomi";
        href = "mimarket://details?id=com.yddmi.doctor";
      } else if (/SamSung/i.test(userAgent)) {
        brand = "SamSung";
        href = "samsungapps://ProductDetail/com.yddmi.doctor";
      } else if (/vivo/i.test(userAgent)) {
        brand = "vivo";
        href = "vivomarket://details?id=com.yddmi.doctor";
      } else if (/HeyTapBrowser/i.test(userAgent)) {
        brand = "oppo";
        href = "oppomarket://details?packagename=com.yddmi.doctor";
      }
      return href;
    },

    closeWeb() {
      this.copyLink();
      if (this.judgeClient() == "Android") {
        this.closeWebAndroid();
      } else if (this.judgeClient() == "IOS") {
        this.closeWebIOS();
      } else {
      }
      setTimeout(()=>{
        this.download();
      },3000)
    },

    closeWebAndroid() {
      if (this.$route.query.inviteSign) {
        window.location.href =
          "openapp://syyxcloud.com.doctor?shareCode=" +
          this.inviteSign;
          alert(window.location.href)
      } else {
        window.location.href = "openapp://syyxcloud.com";
      }
    },

    closeWebIOS() {
      if (this.$route.query.inviteSign) {
        if(this.isSource){
          window.location.href =
          "ydd9857://app/shareToLogin?shareCode=" +
          this.inviteSign;
        }else{
          window.location.href =
          "ydd9528://app/shareToLogin?shareCode=" +
          this.inviteSign;
        }
        
      } else {
        if(this.isSource){
          window.location.href = "ydd9857://";
        }else{
          window.location.href = "ydd9528://";
        }
      }
    },

    judgeClient() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //判断是否是 android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
      if (isAndroid) {
        return "Android";
      } else if (isIOS) {
        return "IOS";
      } else {
        return "PC";
      }
    },

    filterUrl(url) {
      return this.imgUrl + url;
    },
    async getvisitorId() {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      this.visitorId = result.visitorId;
      console.log("唯一标识", this.visitorId);
    },
    async getDetail() {
      await this.getvisitorId();
      console.log("结束");
      let params = {
        deviceCode: this.visitorId,
        shareType: 2,
        inviteSignStr: this.inviteSign,
        practiceListId: this.$route.query.practiceListId,
      };
      let res = await getScoreDetail(params);
      this.info = res.data;
    },
   
  },
};
</script>

<style lang="scss" scoped>
.app-content {
  height: 100%;
  box-sizing: border-box;
  .openAppStyle{
    z-index: 99;
    opacity: 0.3;
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    #openApp,#openApp2{
      position: absolute;
      top:0;
      left:0;
      width:100%;
      height:100%;
      div{
        width:100%;
        height:100%;
        button{
          width:100%;
          height:100%;
        }
      }
    }
    
  }
  .popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.4);
    // opacity: 0.2;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    .popup-content {
      .receive-img-block {
        position: relative;
        .popup-bg {
          position: relative;
          z-index: 5;
        }
        .close-icon {
          width: .5067rem;
          height: .5067rem;
          position: absolute;
          right: .8rem;
          top: 0;
          z-index: 6;
        }
        .recBtnStyle {
          position: absolute;
          width: 4.88rem;
          height: 1.0667rem;
          bottom: 1.3333rem;
          left: 50%;
          transform: translateX(-50%);
          z-index: 6;
          display: flex;
          align-items: center;
        }
      }
      .receive-tips-block {
        width: 90vw;
        background-color: #fff;
        border-radius: .2133rem;
        box-sizing: border-box;
        padding: .2667rem 1rem;
        position: relative;
        .receive-tips-block-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: .5333rem;
          .receive-tips-block-title-text {
            color: #000000;
            font-weight: bold;
            font-size: 20px;
          }
          .receive-tips-block-close {
            position: absolute;
            top: .32rem;
            right: .5333rem;
            width: .3733rem;
            height: .3733rem;
          }
        }

        .receive-tips-block-content {
          display: flex;
          gap: .1875rem;
          margin-bottom: .5333rem;
          .receive-tips-block-content-icon {
            width: .5067rem;
            flex-shrink: 0;
            transform: translateY(2px);
            img {
              width: .5067rem;
              height: .5067rem;
            }
          }
          .receive-tips-block-content-text {
            flex: 1;
            color: #828282;
            font-size: 16px;
          }
        }
        .receive-tips-block-actions {
          display: flex;
          align-items: center;
          justify-content: space-around;
          .cancelOpenBut{
            width: 2.6667rem;
            height: .8rem;
            position: relative;
            background-color: transparent;
            img {
             width:100%;
             height: 100%;
            }
            
          }
        }
      }
    }
  }
  .bg {
    img{
      width:100%;
    }
  }
}
.video-container {
  // padding: 0 .5333rem;
  width: 100%;
  z-index: 2;
}
video {
  width: 100%;
  display: block;
}
img {
  width: 100%;
  display: block;
}
.btn {
  z-index: 88;
  position: fixed;
  bottom: 0.5333rem;
  left: 50%;
  transform: translateX(-50%);
  width: 9.625rem;
  height: 1.1875rem;
  border-radius: 1.1875rem;
  background-color: #3E73FF;
  color: #fff;
  text-align: center;
  font-size: 0.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  word-spacing:.05rem;
  letter-spacing:.05rem;

}  
.openApp2Font{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.openIcon{
  display: inline-block;
  background-image: url("../../assets/icons/openIcon.png");
  background-size: .625rem .5rem;
  width:.625rem;
  height: .5rem;
  margin-right: .1rem;
}
.zhezhao {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 88;
  img {
    width: 100%;
    height: 100%;
    //   background-color: #47444467;
  }
}
</style>
